import leezenCustomerManagementReducer from "./leezenCustomerManagementReducer";
import customerRawMaterialReducer from "./customerRawMaterialReducer";

const leezenCustomerManagementReducers = {
    leezenCustomerManagement: leezenCustomerManagementReducer,
    customerRawMaterial: customerRawMaterialReducer,
}

export default leezenCustomerManagementReducers;